<div class="seo-search">
  <h2 class="seo-search__title">
    {{ destination.name }}
  </h2>

  <div
    mb-expandable-text
    height="288px"
    class="seo-search__description">

    <p>
      {{ destination.description }}
    </p>

    <span mb-expand>Ver más</span>
    <span mb-collapse>Ver menos</span>
  </div>
</div>
